<template>
    <v-card>
        <v-col cols="12">
          <div v-if="isQueryLoaded && !queryData.length" class="text-center py-8">
            <v-progress-circular indeterminate color="#00004d"></v-progress-circular>
            <p class="mt-3 mb-0">Searching...</p>
          </div>
          <template v-else>
          <h1>{{totalRecords}} Project(s) found for "{{query}}"</h1>
          <p v-for="(item, i) in queryData" :key="i" class="search-results-p mb-5">
            <v-card>
              <v-card-text>
                <span>
                  <a class="hidden-md-and-up" :href="'/developments-management/projects?project='+item.id">
                    <span class="font-weight-bold">{{ item.title }}</span>
                    <span v-if="item.hk"><br><br>{{ item.hk }}</span>
                  </a>
                  <a class="hidden-sm-and-down" :href="'/developments-management/projects?project='+item.id" target="_blank">
                    <span class="font-weight-bold">{{ item.title }}</span>
                    <span v-if="item.hk"><br><br>{{ item.hk }}</span>
                  </a>
                  <span v-if="item.description" v-html="sanitizeRichHtmlExcerpt(item.description)"></span>
                </span>
              </v-card-text>
            </v-card>
          </p>
          <div class="text-center">
            <div v-if="isQueryLoaded && queryData.length" class="py-4">
              <v-progress-circular indeterminate size="24" color="#00004d"></v-progress-circular>
            </div>
            <v-btn @click="loadMore" color="primary" v-else-if="totalRecords > 15 && page !== lpage" center>Load More</v-btn>
          </div>
          </template>
        </v-col>
    </v-card>
  </template>
  
<script>
  import {bus} from "@/main";
  import {runQuickSearchTabRequest} from "./quickSearchTabRequest";
  export default {
    name: "projectQS",
    props: ['query'],
    data() {
      return {
        isQueryLoaded: false,
        queryData: [],
        page: 1,
        lpage: 1,
        totalRecords: 0,
        requestToken: 0,
      };
    },
    mounted() {
      this.getQueryData();
      if (this.$store.state.qsQuery.length >= 3) {
        bus.$on('qsDialogOpen', data => {
          this.isQueryLoaded = true
          this.queryData = []
          this.page = 1
          this.lpage = 1
          this.totalRecords = 0
          this.getQueryData();
        });
      }
      if (this.$store.state.qsQuery.length >= 3) {
        bus.$on('qsFormUpdated', data => {
          this.isQueryLoaded = true
          this.queryData = []
          this.page = 1
          this.lpage = 1
          this.totalRecords = 0
          this.getQueryData();
        });
      }
      bus.$on('qsDialogClosed', data => {
        this.requestToken++
        this.queryData = []
        this.page = 1
        this.lpage = 1
        this.totalRecords = 0
        this.isQueryLoaded = false
      });
    },
    computed: {
      
    },
    methods: {
      getQueryData() {
        runQuickSearchTabRequest(this, 'project');
      },
      loadMore(){
        this.page++
        this.getQueryData()
      }
    }
  };
</script>